export const measurementConstants = {
  GET_SINGLE_REQUEST: "MEASUREMENT_GET_SINGLE_REQUEST",
  GET_SINGLE_SUCCESS: "MEASUREMENT_GET_SINGLE_SUCCESS",
  GET_SINGLE_FAILURE: "MEASUREMENT_GET_SINGLE_FAILURE",

  GET_ALL_REQUEST: "MEASUREMENT_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "MEASUREMENT_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "MEASUREMENT_GET_ALL_FAILURE",

  ADD_REQUEST: "MEASUREMENT_ADD_REQUEST",
  ADD_SUCCESS: "MEASUREMENT_ADD_SUCCESS",
  ADD_FAILURE: "MEASUREMENT_ADD_FAILURE",

  UPDATE_REQUEST: "MEASUREMENT_UPDATE_REQUEST",
  UPDATE_SUCCESS: "MEASUREMENT_UPDATE_SUCCESS",
  UPDATE_FAILURE: "MEASUREMENT_UPDATE_FAILURE",

  DELETE_REQUEST: "MEASUREMENT_DELETE_REQUEST",
  DELETE_SUCCESS: "MEASUREMENT_DELETE_SUCCESS",
  DELETE_FAILURE: "MEASUREMENT_DELETE_FAILURE",

  CLEAR: "MEASUREMENT_CLEAR",
};
